import 'twin.macro';
import 'styled-components/macro';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { FavoritesPageIcon } from 'toy/atoms/favorites-page-icon/FavoritesPageIcon';
import { useFavoritesContext } from 'toy/context/Favorites';

import SweetShoppingCartWidget from '../atoms/sweet-shopping-cart-widget/SweetShoppingCartWidget';
import { useShoppingCartContext } from '../context/ShoppingCart';

interface ToyTemplateProps {
  children: React.ReactNode;
}

const ToyTemplate = ({ children }: ToyTemplateProps) => {
  const { cartItemsCount } = useShoppingCartContext();
  const { items } = useFavoritesContext();

  return (
    <div tw="flex flex-col max-w-4xl w-full mx-auto">
      <header tw="flex justify-between items-center my-1">
        <nav tw="m-2 flex gap-2">
          <Link tw="link" to="/toy-shop">
            🏠 Home
          </Link>
          <Link tw="link" to="/toy-shop/sweet">
            🍬 Sweets
          </Link>
        </nav>
        <div tw="flex gap-2">
          <Link to="/toy-shop/favorites">
            <FavoritesPageIcon itemsCount={items.length} />
          </Link>
          <Link to="/toy-shop/cart">
            <SweetShoppingCartWidget itemsCount={cartItemsCount} />
          </Link>
        </div>
      </header>
      <main tw="flex-1 rounded bg-white shadow-card p-2">{children}</main>
    </div>
  );
};

export default ToyTemplate;
